import { render, staticRenderFns } from "./PageSearch_Search.vue?vue&type=template&id=a657320c"
import script from "./PageSearch_Search.vue?vue&type=script&lang=js"
export * from "./PageSearch_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports